import Mahogany1 from "../Summarecon Bogor/Mahogany.webp"
import Mahogany2 from "../Summarecon Bogor/Mahogany.webp"

const Mahoganyimages =[
    Mahogany1,Mahogany2
]

export default Mahoganyimages;